import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/utamed-logo-horizontal-blanco.svg")